import React from "react";
import _Input from "../generic/_Input";
import { Button, Spinner } from "react-bootstrap";
import PropTypes from "prop-types";
import { ErrorMessage, WarningMessage } from "../../utils/toastify";
import { errorLabels } from "../../utils/helpers";

const Init2fa = ({ formik, isLoading = false }) => {
  const _action = async (e) => {
    e.preventDefault();
    try {
      const isValid = await formik.validateForm();

      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <div className="bg-white rounded-lg px-4 py-4 w-full max-w-[300px] lg:max-w-[500px]">
      <h1 className="text-3xl font-bold text-gray-600">Iniciar sesión</h1>
      <form className="flex flex-col" onSubmit={_action}>
        <_Input
          name="user"
          title="Usuario"
          required
          placeholder="Usuario"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.user}
          isError={formik.errors && formik.errors.user}
          errors={formik.errors && formik.touched ? formik?.errors.user : ""}
        />
        <_Input
          name="password"
          title="Contraseña"
          type="password"
          required
          placeholder="Contraseña"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
          isError={formik.errors && formik.errors.password}
          errors={
            formik.errors && formik.touched ? formik?.errors.password : ""
          }
        />

        <h6
          className="forgetPass my-2 cursor-pointer"
          onClick={() => {
            WarningMessage("Comuniquese con el administrador");
          }}
        >
          <a className="border-line">¿Olvidaste tu contraseña?</a>
        </h6>

        <div className="Send">
          <Button
            disabled={isLoading}
            variant="primary"
            type="submit"
            className="w-full"
          >
            {isLoading ? (
              <Spinner size="sm" animation="border" className="w-full" />
            ) : (
              "Ingresar"
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};

Init2fa.propTypes = {
  formik: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default Init2fa;
